/**
 * @ngdoc overview
 * @name evtviewer.analoguesApparatusEntry
 * @description 
 * # evtviewer.analoguesApparatusEntry
 * Module referring to analogue apparatus entries.
 * 
 * ## Services
 * - {@link evtviewer.analoguesApparatusEntry.evtAnaloguesApparatusEntry evtAnaloguesApparatusEntry} where the scope of 
 * {@link evtviewer.analoguesApparatusEntry.directive:evtAnaloguesApparatusEntry evtAnaloguesApparatusEntry} directive 
 * is expanded and stored untill the directive remains instantiated.
 *
 * ## Directives
 * - {@link evtviewer.analoguesApparatusEntry.directive:evtAnaloguesApparatusEntry evtAnaloguesApparatusEntry}: custom directive 
 * that will show the content of an analogue apparatus entry
 *
 * ## Controllers
 * - {@link evtviewer.analoguesApparatusEntry.controller:analoguesApparatusEntryCtrl analoguesApparatusEntryCtrl}: controller for the 
 * {@link evtviewer.analoguesApparatusEntry.directive:evtAnaloguesApparatusEntry evtAnaloguesApparatusEntry} directive.
**/
angular.module('evtviewer.analoguesApparatusEntry', []);